import { connect } from 'react-redux';
import ContainerCardsWrapper from './ContainerCardsWrapper';
import { getInvalidItemsCount } from '../../../selectors/getInvalidItemsCount';
import { getDiscontinuedItemsCount } from '../../../selectors/getDiscontinuedItemsCount';
import { getPhoneNumber } from '../../../utils/index';

const mapStateToProps = ({ originReducer, estimateBuilder }) => {
  const { entities, uiState } = estimateBuilder;
  const invalidItemsCount = getInvalidItemsCount(entities, uiState.selectedEstimate);
  const discontinuedItemsCount = getDiscontinuedItemsCount(entities, uiState.selectedEstimate);
  const { isLockedOrOrdered } = entities.estimates.byId[uiState.selectedEstimate];
  const { isMandi } = entities.estimates.byId[uiState.selectedEstimate].attributes || false;
  const { mode } = originReducer;
  const phoneNumber = getPhoneNumber(mode);

  return {
    invalidItemsCount,
    discontinuedItemsCount,
    isLockedOrOrdered,
    isMandi,
    phoneNumber,
  };
};

export default connect(mapStateToProps)(ContainerCardsWrapper);
